export default __webpack_public_path__ + "static/coperta-retete-hb-11ffb266a48045f9d6c295a5888990dd.jpg";